"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ProductType_1 = __importDefault(require("./ProductType"));
var core_1 = require("@material-ui/core");
var default_extensionCord_png_1 = __importDefault(require("../assets/images/default_extensionCord.png"));
var default_plug_png_1 = __importDefault(require("../assets/images/default_plug.png"));
var delault_light_png_1 = __importDefault(require("../assets/images/delault_light.png"));
var delault_security_png_1 = __importDefault(require("../assets/images/delault_security.png"));
var ProductItem_1 = __importDefault(require("./ProductItem"));
var usePrductData_1 = __importDefault(require("../use/usePrductData"));
var navList = [
    { textId: "lightPorduct", image: delault_light_png_1.default },
    { textId: "plugPorduct", image: default_plug_png_1.default },
    { textId: "extensionCordPorduct", image: default_extensionCord_png_1.default },
    { textId: "securityPorduct", image: delault_security_png_1.default }
];
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        root: {
        // alignItems :"center"
        },
        itemPaper: {
            marginLeft: '50%',
            transform: 'translate(-50%)',
            boxShadow: 'none'
        },
        item: {
            justifyContent: "center"
        },
    });
});
var ProductLayout = function () {
    var _a = react_1.useState(navList[0].textId), type = _a[0], setType = _a[1];
    var products = usePrductData_1.default(type);
    var hash = window.location.hash;
    console.log("hash : " + hash);
    react_1.useEffect(function () {
        if (hash) {
            var anchor = document.querySelector(hash);
            if (anchor) {
                anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [hash]);
    var handleChangeType = function (textId) {
        setType(textId);
    };
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Container, { maxWidth: "xl", id: "go-to-product-anchor" },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 }, navList.map(function (_a, index) {
                var textId = _a.textId, image = _a.image;
                return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 6, lg: 3, sm: 6, key: index },
                    react_1.default.createElement(ProductType_1.default, { changeType: handleChangeType, textId: textId, index: index, image: image })));
            }))),
        react_1.default.createElement(core_1.Container, { maxWidth: "xl" },
            react_1.default.createElement(core_1.Grid, { className: classes.item, container: true, spacing: 2 }, products.map(function (_a, index) {
                var title = _a.title, content = _a.content, image = _a.image, info = _a.info, type = _a.type;
                return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 6, lg: 3, sm: 6, key: index },
                    react_1.default.createElement(ProductItem_1.default, { index: index, title: title, content: content, image: image, type: type, info: info })));
            })))));
};
exports.default = ProductLayout;
